import {useState,useEffect} from 'react'


function useBusinessInfo(masterNameList,type) {
    const [businessInfo,setBusineeInfo] = useState(null);
    const getBusinessInfo = () =>{
    }
    useEffect(()=>{
        getBusinessInfo();
    },[])
    return businessInfo;
}

export default useBusinessInfo